import { randomNumber } from '../../../utilities'
import { CompleteChartConstants } from './completeChart.constants'
import {
  ICompleteChartAction,
  ICompleteChartState,
  IServicesBilling,
  ISigner,
  ISignerAction,
  ISignerState,
} from './completeChart.types'

export const initialServicesBillingState: IServicesBilling = {
  emergencyCriteria: null,
  als2MedsExclude: null,
  sctRnIh: null,
  als1IVmeds: null,
}

export const initialCompleteChartState: ICompleteChartState = {
  selectedOption: CompleteChartConstants.SET_ERRORS_TAB,
  lockChart: 0,
  servicesBilling: initialServicesBillingState,
  cmsSvcLevel: null,
  datasetDeterminationSet: false,
  datasetDetermination: [],
}

export const initialSigner = (): ISigner => {
  return {
    key: randomNumber().toString(),
    user: null,
    signChartAs: null,
    pin: '',
    answer1: '',
    answer2: '',
    questionList: [],
    verified: false,
    isClinicalUser: true,
    dt: '',
    extraSecurityId: null,
  }
}

export const initialSignerState: ISignerState = {
  signerList: [],
  user: null,
  signChartAs: null,
  pin: '',
  answer1: '',
  answer2: '',
  currentSigner: null,
  signer: null,
  questionList: [],
  clinicalUserList: [],
  complexRulesCount: [],
  securityQuestionAnswerList: [],
  verified: false,
  extraSecurityId: null,
  isClinicalUser: true,
}

export function completeChartReducer(
  state: ICompleteChartState = initialCompleteChartState,
  action: ICompleteChartAction
): ICompleteChartState {
  switch (action.type) {
    case CompleteChartConstants.SET_SELECTED_OPTION:
      return { ...state, selectedOption: action.selectedOption }
    case CompleteChartConstants.SET_LOCK_CHART:
      return { ...state, lockChart: action.lockChart }
    case CompleteChartConstants.SET_SERVICES_BILLING:
      return { ...state, servicesBilling: action.servicesBilling }
    case CompleteChartConstants.SET_CMS_VALUE:
      return { ...state, cmsSvcLevel: action.cmsSvcLevel }
    default:
      return state
  }
}

export function signerReducer(state: ISignerState = initialSignerState, action: ISignerAction): ISignerState {
  switch (action.type) {
    case CompleteChartConstants.ADD_SIGNER:
      return {
        ...state,
        signerList: [...state.signerList, initialSigner()],
      }
    case CompleteChartConstants.DELETE_SIGNER:
      return { ...state, signer: action.signer }
    case CompleteChartConstants.SET_CURRENT_SIGNER:
      return { ...state, currentSigner: action.currentSigner }
    case CompleteChartConstants.SET_SIGNER_LIST:
      return { ...state, signerList: action.signerList }
    case CompleteChartConstants.SET_USER:
      return { ...state, user: action.user, signer: action.signer }
    case CompleteChartConstants.SET_SIGN_CHART_AS:
      return { ...state, signChartAs: action.signChartAs, signer: action.signer }
    case CompleteChartConstants.SET_PIN:
      return { ...state, pin: action.pin, signer: action.signer }
    case CompleteChartConstants.SET_QUESTION_LIST:
      return { ...state, questionList: action.questionList, signer: action.signer }
    case CompleteChartConstants.SET_CLINICAL_USER_LIST:
      return { ...state, clinicalUserList: action.clinicalUserList }
    case CompleteChartConstants.SET_SECURITY_QUESTION_ANSWER_LIST:
      return { ...state, securityQuestionAnswerList: action.securityQuestionAnswerList }
    case CompleteChartConstants.SET_COMPLEX_RULES_COUNT:
      return { ...state, complexRulesCount: action.complexRulesCount }
    case CompleteChartConstants.SET_ANSWER1:
      return { ...state, answer1: action.answer1, signer: action.signer }
    case CompleteChartConstants.SET_ANSWER2:
      return { ...state, answer2: action.answer2, signer: action.signer }
    case CompleteChartConstants.SET_VERIFY_CREW:
      return { ...state, verified: action.verified, signer: action.signer }
    case CompleteChartConstants.SET_CLINICAL_USER:
      return { ...state, isClinicalUser: action.isClinicalUser, signer: action.signer }
    case CompleteChartConstants.SET_EXTRA_SECURITY_ID:
      return { ...state, extraSecurityId: action.extraSecurityId, signer: action.signer }
    case CompleteChartConstants.RESET_SIGNER:
      return {
        ...initialSignerState,
      }
    default:
      return state
  }
}
